/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Element } from 'react-scroll'
import classnames from 'classnames'
import AddToCartButton from '../../generic/AddToCartButton/'
import './styles.css'

class CourseSummary extends Component {
  getCSSClassesFor(baseClass) {
    switch (baseClass) {
      case 'content':
        return this.props.price ? 'content content--with-buy-info' : 'content'
      case 'content__teacher':
        return this.props.variant === 'darkContentText'
          ? 'content__teacher content__teacher--dark'
          : 'content__teacher content__teacher--clear'
      case 'content__title':
        return this.props.variant === 'darkContentText'
          ? 'content__title content__title--dark'
          : 'content__title content__title--clear'
      default:
        return ''
    }
  }

  render() {
    const { props } = this
    const linkTo = props.isSpecial
      ? `/special-videos/${props.slug}`
      : (props.isWebinar ? `/webcourses/${props.slug}` : (props.isCurrentlyWatching ? `/tutorials/${props.slug}?watch=1` : `/tutorials/${props.slug}`))
    return (
      <div
        className={classnames('course-summary', { [props.className]: props.className })}
      >
        <Element name={props.elementName}>
          {props.isQuickPlay && (
            <a className="quickplay" onClick={() => props.onQuickPlayClick()} href="#" role="button" aria-label={`Interact to play ${props.title}`}>
              <div className="header__thumb">
                <img src={props.thumb} alt={props.title} />
              </div>
              <div className="info">
                <i className="icon-play" />
              </div>
            </a>
          )}
          {!props.isQuickPlay && (
            <Link to={linkTo}>
              <div className="header">
                {props.new && <div className="new-course-badge">new course</div>}
                {props.completed && <div className="completed-course-badge">Completed</div>}
                <div className="header__thumb">
                  <img src={props.thumb} alt={props.title} />
                </div>
                <div className="info">
                  <p className="info__text">
                    {props.summary}
                  </p>
                </div>
                {!!props.isSpecial && (
                  <div className="badge badge--special">
                    <span className="badge--special__text">Special Video</span>
                  </div>
                )}
                {!!props.isWebinar && (
                  <div className="badge badge--live">
                    <span className="badge--live__dot" role="presentation" />
                    <span className="badge--live__text">Live Course</span>
                  </div>
                )}
              </div>
            </Link>
          )}
          <div className={this.getCSSClassesFor('content')}>
            {!props.isSpecial && (
              <Link to={`/artists/${props.teacherSlug}`}>
                <p
                  className={this.getCSSClassesFor('content__teacher')}
                  title={props.teacher}
                >
                  {props.teacher}
                </p>
              </Link>
            )}
            {props.isSpecial && (
              <Link to="/stan-winston-school-of-character-arts">
                <p
                  className={this.getCSSClassesFor('content__teacher')}
                  title="Stan Winston School"
                >
                  Stan Winston School
                </p>
              </Link>
            )}
            {!props.isQuickPlay && (
              <Link to={props.isSpecial ? `/special-videos/${props.slug}` : (props.isWebinar ? `/webcourses/${props.slug}` : `/tutorials/${props.slug}`)}>
                <h3 className={this.getCSSClassesFor('content__title')}>{props.title}</h3>
              </Link>
            )}
            {props.isQuickPlay && (
              <a href="#" onClick={() => props.onQuickPlayClick()} role="button" aria-label={`Interact to play ${props.title}`}>
                <h3 className={this.getCSSClassesFor('content__title')}>{props.title}</h3>
              </a>
            )}
            {props.price !== undefined && (
              <div className="buy-info">
                <p className="buy-info__price">${props.price}</p>
                <AddToCartButton
                  className="buy-info__cta"
                  type="secondary"
                  url={props.purchaseUrl}
                >
                  Add To Cart
                </AddToCartButton>
              </div>
            )}
          </div>
        </Element>
      </div>
    )
  }
}

const purchaseProps = {
  price: PropTypes.number,
  purchaseUrl: PropTypes.string
}

CourseSummary.propTypes = {
  ...purchaseProps,
  className: PropTypes.string,
  isSpecial: PropTypes.bool,
  isWebinar: PropTypes.bool,
  isCurrentlyWatching: PropTypes.bool,
  elementName: PropTypes.string,
  slug: PropTypes.string.isRequired,
  summary: PropTypes.string,
  teacher: PropTypes.string.isRequired,
  teacherSlug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  thumb: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['clearContentText', 'darkContentText'])
}

export default CourseSummary
